import { Link } from '@remix-run/react';
import { GQLImageSplitCtaFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { ButtonSize, OutlineLinkButton, PromoImageContainer, RichText, SmallArrowIcon } from '@theprintbar/ui';

interface ImageSplitCTAProps {
	className?: string;
	content: Pick<GQLImageSplitCtaFragment, 'imageSplitCTA'>;
	clickableBlocks?: boolean;
}

export const ImageSplitCTA = ({ content, className, clickableBlocks }: ImageSplitCTAProps) => {
	const ctas = content.imageSplitCTA?.structure;
	if (!ctas) return null;

	return (
		<div className={cn('grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7', className)}>
			{ctas.map((cta, index) => {
				if (!cta) return null;

				const contentBlock = (
					<div key={index} className="rounded-3xl border border-blue overflow-hidden relative p-8">
						<div className="absolute inset-0 z-10">
							<PromoImageContainer promoImage={cta?.image} className="w-full h-full" />
							<div className="absolute inset-0 bg-black/60" />
						</div>

						<div className="relative z-10 max-w-sm">
							<div className={cn('lg:mb-28 text-white-pearl h-full space-y-5')}>
								<h2 className="lg:text-xl text-lg">{cta?.title}</h2>
								<RichText className="space-y-2" {...cta.text} />
								{cta.links?.map(link =>
									link ? (
										<OutlineLinkButton
											className="border border-white-pearl bg-transparent fill-white-pearl stroke-white-pearl hover:bg-blue text-white-pearl"
											to={link.to || '#'}
											icon={SmallArrowIcon}
											iconSize={ButtonSize.S}
											key={link.text}
										>
											<h5 className="text-xs uppercase">{link.text}</h5>
										</OutlineLinkButton>
									) : null,
								)}
							</div>
						</div>
					</div>
				);

				return clickableBlocks ? (
					<Link to={cta.links?.[0]?.to || '#'} key={index}>
						{contentBlock}
					</Link>
				) : (
					contentBlock
				);
			})}
		</div>
	);
};
